import React from 'react';

const COUNTRY_CODES = [
  { code: '+91', label: 'IND (+91)', flag: '🇮🇳' },
  { code: '+1', label: 'USA (+1)', flag: '🇺🇸' },
  { code: '+44', label: 'UK (+44)', flag: '🇬🇧' },
  { code: '+971', label: 'UAE (+971)', flag: '🇦🇪' },
  { code: '+61', label: 'AUS (+61)', flag: '🇦🇺' },
  { code: '+65', label: 'SGP (+65)', flag: '🇸🇬' },
  { code: '+1', label: 'CAN (+1)', flag: '🇨🇦' },
];

const PhoneInput = ({ 
  value, 
  onChange, 
  label, 
  required = false, 
  error,
  placeholder = "XXXXXXXXXX",
  disabled = false
}) => {
  // Robust parsing of value like "+91 9876543210" or just "9876543210"
  let countryCode = '+91';
  let phoneNumber = '';

  if (value) {
    if (value.startsWith('+')) {
      const firstSpace = value.indexOf(' ');
      if (firstSpace !== -1) {
        countryCode = value.substring(0, firstSpace);
        phoneNumber = value.substring(firstSpace + 1).replace(/\D/g, '');
      } else {
        // Handle cases like "+919876543210"
        // Try to match against components of COUNTRY_CODES
        const matchingCode = COUNTRY_CODES.find(c => value.startsWith(c.code));
        if (matchingCode) {
          countryCode = matchingCode.code;
          phoneNumber = value.substring(matchingCode.code.length).replace(/\D/g, '');
        } else {
          countryCode = '+91';
          phoneNumber = value.replace(/\D/g, '');
        }
      }
    } else {
      phoneNumber = value.replace(/\D/g, '');
    }
  }

  const handleCountryChange = (e) => {
    const newCode = e.target.value;
    onChange(`${newCode} ${phoneNumber}`);
  };

  const handlePhoneChange = (e) => {
    const newPhone = e.target.value.replace(/\D/g, '').slice(0, 10);
    onChange(`${countryCode} ${newPhone}`);
  };

  return (
    <div className={`flex flex-col gap-1.5 ${disabled ? 'opacity-60' : ''}`}>
      {label && (
        <label className={`block text-[10px] font-black uppercase tracking-[0.2em] mb-1.5 ml-1 ${error ? 'text-red-500' : 'text-slate-400'}`}>
          {label.replace(/\s*\*$/, '')} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className={`flex items-center gap-0 border rounded-lg overflow-hidden bg-white transition-all ${
        error ? 'border-red-500 ring-1 ring-red-500' : 'border-gray-300 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500'
      } ${disabled ? 'bg-gray-50 border-gray-200' : ''}`}>
        <select
          value={countryCode}
          onChange={handleCountryChange}
          disabled={disabled}
          className="bg-gray-50 border-r border-gray-200 px-2 py-2 text-sm font-medium text-gray-700 outline-none focus:bg-white transition-colors cursor-pointer disabled:cursor-not-allowed"
        >
          {COUNTRY_CODES.map((c) => (
            <option key={`${c.code}-${c.label}`} value={c.code}>
              {c.flag} {c.code}
            </option>
          ))}
        </select>
        <input
          type="tel"
          value={phoneNumber}
          onChange={handlePhoneChange}
          disabled={disabled}
          placeholder={placeholder}
          className="flex-1 px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 outline-none disabled:bg-gray-50 disabled:cursor-not-allowed"
        />
      </div>
      {error && (
        <p className="text-xs text-red-600 mt-0.5">{error}</p>
      )}
    </div>
  );
};

export default PhoneInput;
